module.exports = __webpack_public_path__ + "static/media/logo-lundbeck.744bfb46.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logos/logo-lundbeck.png
// module id = 1490
// module chunks = 0